import {useMutation} from 'react-query'

import {mutations} from '../../mutations'

export const usePostSlotRelease = () => {
  return useMutation(mutations.postSlotRelease)
}
